export const getBrowserTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone

export const getTimezoneHeader = () => ({ 'x-timezone': getBrowserTimezone() })
